import { render, staticRenderFns } from "./topThree.vue?vue&type=template&id=6d46fd87&scoped=true"
import script from "./topThree.vue?vue&type=script&lang=js"
export * from "./topThree.vue?vue&type=script&lang=js"
import style0 from "./topThree.vue?vue&type=style&index=0&id=6d46fd87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d46fd87",
  null
  
)

export default component.exports